import type { OptOutNode } from '../types';
import { toString } from './parse-helpers';

/**
 * Parse opt-out conditions.
 * Handles: { optout: { type: 'SMS', from, inverse } }
 *          { type: 'opt_out', number, inverse }
 */
export function parseOptOut(raw: Record<string, unknown>): OptOutNode | null {
  // Ember format: { optout: { type, from, inverse } }
  if ('optout' in raw && typeof raw.optout === 'object' && raw.optout != null) {
    const optout = raw.optout as Record<string, unknown>;
    return {
      type: 'opt_out',
      inverse: optout.inverse === true,
      channel: toString(optout.from ?? optout.type) ?? 'SMS',
    };
  }

  if (raw.type === 'opt_out') {
    return {
      type: 'opt_out',
      inverse: raw.inverse === true,
      channel: toString(raw.number ?? raw.channel) ?? 'SMS',
    };
  }

  return null;
}
